export default __webpack_public_path__ + "static/media/OM.f2a06944.svg";